const version = "5.3.0";
const publishDates = {
  major: "2026-05-06T16:28:18.473Z",
  minor: "2026-08-05T11:39:54.978Z",
  patch: "2026-08-05T11:39:54.978Z"
};
export {
  publishDates,
  version
};
//# sourceMappingURL=version.mjs.map
